const config = {
  BASE: (import.meta.env.VITE_BASE ?? "/") as string,
  PRODUCTION: import.meta.env.PROD,
  TITLE: (import.meta.env.VITE_TITLE || "") as string,
  API: (import.meta.env.VITE_API || "") as string,
  OSS_BASE: (import.meta.env.VITE_OSS_BASE || "") as string,
};

export { config };
